import { action, createRequestTypes } from '../base';

export const processActionTypes = {
  GET_PROCESSES: createRequestTypes('GET_PROCESSES'),
  GET_PROCESS_BY_ID: createRequestTypes('GET_PROCESS_BY_ID'),
  CREATE_PROCESS: createRequestTypes('CREATE_PROCESS'),
  UPDATE_PROCESS: createRequestTypes('UPDATE_PROCESS'),
  UPDATE_STATUS_PROCESS: createRequestTypes('UPDATE_STATUS_PROCESS'),
  DELETE_PROCESS: createRequestTypes('DELETE_PROCESS'),
};

/**
 * @param payload
 * @param orgId
 * @param status
 * @param limit
 * @param page
 * @param callback
 */
class ProcessActions {
  /**
   * @param {*} orgId
   * @param {*} searchKeyword
   * @param {*} page
   * @param {*} limit
   * @return
   */
    getProcesses = (orgId, page, limit, searchKeyword) => action(processActionTypes.GET_PROCESSES.REQUEST, {
      orgId, page, limit, searchKeyword,
    })

    /**
     *
     * @param {*} getProcessesLoading
     * @return
     */
     getProcessesLoading = (getProcessesLoading) => action(processActionTypes.GET_PROCESSES.LOADING, {
       getProcessesLoading,
     })

     /**
      * @return
      * @param processes
      */
     getProcessesSuccess = (processes) => action(processActionTypes.GET_PROCESSES.SUCCESS, {
       processes,
     })

     /**
      * @param orgId
      * @param {*} processId
      * @return
      */
     getProcessById = (orgId, processId) => action(processActionTypes.GET_PROCESS_BY_ID.REQUEST, {
       orgId, processId,
     })

     /**
      *
      * @param {*} getProcessByIdLoading
      * @return
      */
     getProcessByIdLoading = (getProcessByIdLoading) => action(processActionTypes.GET_PROCESS_BY_ID.LOADING, {
       getProcessByIdLoading,
     })

     /**
      * @return
      * @param selectedProcess
      * @param processData
      */
      getProcessByIdSuccess = (selectedProcess) => action(processActionTypes.GET_PROCESS_BY_ID.SUCCESS, {
        selectedProcess,
      })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    createProcess = (payload, callback) => action(processActionTypes.CREATE_PROCESS.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param {*} createProcessLoading
     * @return
     */
    createProcessLoading = (createProcessLoading) => action(processActionTypes.CREATE_PROCESS.LOADING, {
      createProcessLoading,
    })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
     updateProcess = (payload, callback) => action(processActionTypes.UPDATE_PROCESS.REQUEST, {
       payload,
       callback,
     })

     /**
      *
      * @param {*} updateProcessLoading
      * @return
      */
     updateProcessLoading = (updateProcessLoading) => action(processActionTypes.UPDATE_PROCESS.LOADING, {
       updateProcessLoading,
     })

    /**
     * @param payload
     * @param callback
     * @return {{type: *}}
     */
    updateProcessStatus = (payload, callback) => action(processActionTypes.UPDATE_STATUS_PROCESS.REQUEST, {
      payload, callback,
    })

    /**
     * @param updateProcessStatusLoading
     * @return {{type: *}}
     */
     updateProcessStatusLoading = (updateProcessStatusLoading) => action(processActionTypes.UPDATE_STATUS_PROCESS.LOADING, {
       updateProcessStatusLoading,
     })

     /**
      * @param payload
      * @param callback
      * @return {{type: *}}
      */
    deleteProcess = (payload, callback) => action(processActionTypes.DELETE_PROCESS.REQUEST, {
      payload, callback,
    })

    /**
     * @param deleteProcessLoading
     * @return {{type: *}}
     */
     deleteProcessLoading = (deleteProcessLoading) => action(processActionTypes.DELETE_PROCESS.LOADING, {
       deleteProcessLoading,
     })
}

export default new ProcessActions();
